import Menu from 'Models/Menu';

export default [
  Menu.materialInformation,
  Menu.materialEdit,
  Menu.materialDelete,
  Menu.materialClone,
  Menu.materialAddNotes,
  Menu.materialHelp,
];
